<div class="mobile-sidebar-overlay" (click)="closeMobileSidebar()"></div>
<div class="left-sidebar-pro">
  <nav id="sidebar">
    <div class="sidebar-header" style="height: 65px;">
      <a href="javascript:void(0)" [routerLink]="[myAccountsLink]" style="margin-bottom: 10px !important;">
        <h3 style="padding-bottom: 50px !important;">
          <span>
            <img src="assets/images/logo/bank-logo.svg" [alt]="bankDisplayName" style="height: 45px; width: 45px;" />
          </span>&nbsp;
          {{ bankDisplayName }}
        </h3>
      </a>
      <strong>
        <a href="javascript:void(0)">
          <img src="assets/images/logo/bank-logo.svg" [alt]="bankDisplayName" style="height: 47px;" />
        </a>
      </strong>
    </div>

    <div class="left-custom-menu-adp-wrap comment-scrollbar"> 
      <nav class="sidebar-nav left-sidebar-menu-pro" style="padding-bottom: 80px !important;">
        <ul class="metismenu" id="metismenu" *ngIf="role != 'BRANCH IDENTITY VERIFIER' && role != 'CENTRAL IDENTITY APPROVER' && resetRequired != 'Yes'">
          <li *ngFor="let item of menuJson; let idx = index" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [class.disabled]="item['enabled'] === false || userActivity === 'WaitingForApproval' || userActivity === 'WaitingForVerification' || userActivity === 'WaitingForSelfEkyc'">
            <ng-container>
              <a class="topmenu" [class.has-arrow]="item['leftMenuId']?.length > 0" [attr.aria-expanded]="!item['leftMenuId']?.length" [routerLink]="item['leftMenuId']?.length >= 0 ? topMenu(item['topMenuId']) : [item['leftMenuId'][0].key] ">
                <i class="mdi mdi-menu ic-none"></i>
                <img [src]="topMenuIcons[item.order]" style="width: 18px; height: 18px; margin-right: 10px;">
                <span class="mini-click-non">{{item['topMenuId'] | translate}}</span>
              </a>

              <ul class="submenu-angle collapse" id="{{idx + 1}}" *ngIf="item['leftMenuId']?.length > 0">
                <li *ngFor="let leftmenu of item['leftMenuId']" class="submenu">
                  <ng-container>
                    <a [routerLink]="getRouterLinkByKey(leftmenu.key)" id="{{leftmenu.key}}" routerLinkActive="active" class="submenufs" style="cursor: pointer;" [class.disabled]="leftmenu['enabled'] === false">
                      <img [src]="menuIcons[leftmenu.key]" style="width: 18px; height: 18px; margin-right: 10px;">
                      <span class="mini-sub-pro">{{leftmenu.feature | translate}}</span>
                    </a>
                  </ng-container>
                </li>
              </ul>
            </ng-container>
          </li>
        </ul>
      </nav>
    </div>

    <div class="sidebar-footer" id="footer" style="padding-top: 20px; height: 55px; background-color: #1e3a8a !important;">
      <ul class="list-inline">
        <li class="list-inline-item">
          <a id="banglaLangLink" aria-expanded="false" href="javascript:void(0)" (click)="changeLanguage('bn')">
            <span class="mini-click-non">বাংলা</span>
          </a>
        </li>
        <li class="list-inline-item">|</li>
        <li class="list-inline-item" style="margin-bottom: 15px;">
          <a id="englishLangLink" aria-expanded="false" class="active" href="javascript:void(0)" (click)="changeLanguage('en')">
            <span class="mini-click-non">English</span>
          </a>
        </li>
      </ul>
    </div>

  </nav>
</div>